import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import {Row, Col, Input, FormGroup, Label, Button} from 'reactstrap';
import {CardBody, Card, UncontrolledCollapse} from 'reactstrap';
import {Modal, ModalBody, ModalHeader} from 'reactstrap';

import TopicEdit from './TopicEditComponent';
import AddRemoveList from './AddRemoveListComponent';
import YesNoModal from '../YesNoModalComponent';

import axios from 'axios';
import {serverPath} from "../common";

class CourseEditor extends Component
{
	constructor(props)
	{
		super(props);

		this.state =
			{
				topics:
					{
						classes:[],
						tests:[],
						exams:[]
					},
				courseData:props.courseData,
				topicAddDialogData:
					{
						title:'',
						topicType:0,
						show:false
					},
				confirmDeleteDialogData:
					{
						selectedItem:-1,
						text:'',
						show:false,
						topicType:'',
						topicIndex:-1
					}
			};

		this.onAddClassItem = this.onAddItem.bind(this, 1);
		this.onAddTestItem= this.onAddItem.bind(this, 2);
		this.onAddExamItem= this.onAddItem.bind(this, 4);
		this.onRemoveClassesItem = this.onRemoveItem.bind(this, 'classes');
		this.onRemoveTestsItem = this.onRemoveItem.bind(this, 'tests');
		this.onRemoveExmasItem = this.onRemoveItem.bind(this, 'exams');
		this.renderClassesItem= this.renderItem.bind(this, 'classes');
		this.renderTestsItem= this.renderItem.bind(this, 'tests');
		this.renderExamsItem= this.renderItem.bind(this, 'exams');
		this.onCourseNameChange = this.onCourseNameChange.bind(this);
		this.onCourseShortDescriptionChange= this.onCourseShortDescriptionChange.bind(this);
		this.onAccept = this.onFinish.bind(this, true);
		this.onReject = this.onFinish.bind(this, false);
		this.onToggleAddTopicDialog = this.onToggleAddTopicDialog.bind(this);
		this.onTopicAdded = this.onTopicAdded.bind(this);
		this.onAcceptDelete = this.onConfirmDelete.bind(this, true);
		this.onRejectDelete = this.onConfirmDelete.bind(this, false);
		this.onToggleConfirmDialog = this.onToggleConfirmDialog.bind(this);

	}

	/*Lifecycle code*/
	componentDidUpdate(prevProps)
	{
		if(prevProps.topicList !== this.props.topicList ||
		prevProps.courseData !== this.props.courseData)
		{
			this.onPropsChange();
		}
	}



	/*View/handler code*/
	onPropsChange()
	{
		this.setState(
			{
				...setTopics({}, this.props.topics),
				...setCourseData({}, this.props.courseData)
			}
		);
	}

	onAddItem(topicType)
	{
		let payload = {show:this.state.topicAddDialogData.show};
		payload = setTopicAddDialogData(payload, setTopicAddDialogDataTopicType(payload, topicType));
		payload = setTopicAddDialogData(payload.topicAddDialogData, topicAddDialogDataToggle(payload));

		if(topicType === 1)
		{
			payload = setTopicAddDialogData(payload.topicAddDialogData,
				setTopicAddDialogDataTitle(payload, 'Dodavanje novog casa'));
		}
		else if(topicType === 2 || topicType === 3)
		{
			payload = setTopicAddDialogData(payload.topicAddDialogData,
				setTopicAddDialogDataTitle(payload, 'Dodavanje novog kolokvijuma'));
		}
		else if(topicType === 4 || topicType === 5)
		{
			payload = setTopicAddDialogData(payload.topicAddDialogData,
				setTopicAddDialogDataTitle(payload, 'Dodavanje novog ispita'));
		}

		this.setState(payload);
	}

	onRemoveItem(topicType, index)
	{
		let topicId = -1;
		let name = '';

		if(topicType === 'classes')
		{
			topicId = this.state.topics.classes[index].id;
			name =  this.state.topics.classes[index].name;
		}
		else if(topicType === 'tests')
		{
			topicId = this.state.topics.tests[index].id;
			name =  this.state.topics.tests[index].name;
		}
		else if(topicType === 'exams')
		{
			topicId = this.state.topics.exams[index].id;
			name =  this.state.topics.exams[index].name;
		}

		const text = (
				<div>
					Da li ste sigurni da zelite da birsete
					<b> {name}</b>
				</div>
			)
		this.setState(setConfirmDeleteDialogData(this.state.confirmDeleteDialogData,
			{
				...setConfirmDeleteDialogSelectedItem(this.state.confirmDeleteDialogData,
					topicId),
				...toggleConfirmDeleteDialog(this.state.confirmDeleteDialogData),
				...setConfirmDeleteDialogTopicIndex(this.state.confirmDeleteDialogData, index),
				...setConfirmDeleteDialogTopicType(this.state.confirmDeleteDialogData, topicType),
				...setConfirmDeleteDialogText(this.state.confirmDeleteDialogData, text)

			}));
	}

	onCourseNameChange(event)
	{
		this.setState(setCourseData(this.state.courseData,
			setCourseDataName(this.state.courseData,event.target.value))
		);
		this.props.onNameChange(event.target.value);
	}

	onCourseShortDescriptionChange(event)
	{
		this.setState(setCourseData(this.state.courseData,
			setCourseDataShortDescription(this.state.courseData, event.target.value)));
	}

	onFinish(accept)
	{
		if(accept)
		{
			axios.post(`${serverPath}/professorService.php`,
					{
						courseId:this.props.courseId,
						...this.state.courseData
					},
					{
						params:
							{
								action: 'setCourseData'
							}
					})
				.then((response)=>
				{
					this.props.onFinish(null)
				});
		}
		else
		{
			this.props.onFinish(null);
		}
	}

	onTopicAdded(topicData)
	{

		if(!topicData)
		{
			this.setState(setTopicAddDialogData(this.state.topicAddDialogData,
				topicAddDialogDataToggle(this.state.topicAddDialogData)));
			return ;
		}


		let res = {};
		let tmp = {};
		res.id = topicData.topicId;
		if(topicData.topicData.type === 1)
		{
			res.name = `Tema ${topicData.topicData.week}: ${topicData.topicData.name}`;

			tmp = topicsAddClass(this.state.topics, res);
		}
		else if(topicData.topicData.type === 2 || topicData.topicData.type === 3)
		{
			res.name = `${topicData.topicData.year}: ${topicData.topicData.name}`;
			tmp = topicsAddTest(this.state.topics, res);
		}
		else if(topicData.topicData.type === 4 || topicData.topicData.type === 5)
		{
			res.name = `${topicData.topicData.year}: ${topicData.topicData.name}`;
			tmp = topicsAddExam(this.state.topics, res);
		}

		this.setState(
			{
				...setTopicAddDialogData(this.state.topicAddDialogData,
					topicAddDialogDataToggle(this.state.topicAddDialogData)),
				...setTopics(this.state.topics,
					tmp)
			});

	}

	onToggleAddTopicDialog()
	{
		this.setState(
			setTopicAddDialogData(this.state.topicAddDialogData,
				topicAddDialogDataToggle(this.state.topicAddDialogData))
		);
	}

	onToggleConfirmDialog()
	{
		this.setState(setConfirmDeleteDialogData(this.state.confirmDeleteDialogData,
			toggleConfirmDeleteDialog(this.state.confirmDeleteDialogData)));
	}

	onConfirmDelete(answer)
	{
		let tmp = {};

		if(answer)
		{
			axios.post(`${serverPath}/professorService.php`,
				{
					topicId:this.state.confirmDeleteDialogData.selectedItem
				},
				{
					params:
						{
							action:'deleteTopic'
						}

				});

			if(this.state.confirmDeleteDialogData.topicType === 'classes')
			{
				tmp = setTopics(this.state.topics,
					topicsRemoveClass(this.state.topics,
						this.state.confirmDeleteDialogData.topicIndex));
			}
			else if(this.state.confirmDeleteDialogData.topicType === 'tests')
			{
				tmp = setTopics(this.state.topics,
					topicsRemoveTest(this.state.topics,
						this.state.confirmDeleteDialogData.topicIndex));
			}
			else if(this.state.confirmDeleteDialogData.topicType === 'exmas')
			{
				tmp = setTopics(this.state.topics,
					topicsRemoveExam(this.state.topics,
						this.state.confirmDeleteDialogData.topicIndex));
			}
		}

		this.setState(
			{
				...setConfirmDeleteDialogData(this.state.confirmDeleteDialogData,
					{
						...setConfirmDeleteDialogText(this.state.confirmDeleteDialogData, ''),
						...setConfirmDeleteDialogSelectedItem(this.state.confirmDeleteDialogData, -1),
						...setConfirmDeleteDialogTopicIndex(this.state.confirmDeleteDialogData, -1),
						...setConfirmDeleteDialogTopicType(this.state.confirmDeleteDialogData, ''),

					}),
				...tmp
			});
	}

	/*Render code*/
	renderItem(field, index)
	{
		const item = this.state.topics[field][index];
		return (
			<Row>
				<Col xs='auto'>
					<Link to={`/p/courses/${this.props.courseId}/topic/${item.id}`}>{item.name}</Link>
				</Col>
				<Col>
					<Row className='justify-content-end'>
						<Col xs='auto'>
							<Link to={`/p/courses/${this.props.courseId}/topic/${item.id}/edit`}>
								<Button color='primary' size='sm'>
									Izmeni temu
								</Button>
							</Link>
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}

	render()
	{
		return (
			<React.Fragment>
				<Row>
					<Col>
						<FormGroup>
							<Label>Ime kursa</Label>
							<Input type='text' value={this.state.courseData.name}
								   onChange={this.onCourseNameChange}
							/>
						</FormGroup>
					</Col>
				</Row>

				<Row>
					<Col>
						<FormGroup>
							<Label>Opis kursa</Label>
							<Input type='textarea' value={this.state.courseData.shortDescription}
								   onChange={this.onCourseShortDescriptionChange}
								   style={{height:'300px'}}
							/>
						</FormGroup>
					</Col>
				</Row>

				<Row className='mt-2 justify-content-end'>
					<Col xs='auto'>
						<Button color='success' onClick={this.onAccept}>Prihvati</Button>
					</Col>
					<Col xs='auto'>
						<Button color='danger' onClick={this.onReject}>Odbaci</Button>
					</Col>
				</Row>

				<hr/>

				<Row>
					<Col>
						<h3>Lista tema za ovaj kurs</h3>
					</Col>
				</Row>

				<Row>
					<Col>
						<Card>
							<h4 id='toggleClassesList'
								 style=
									 {
										 {
										 	cursor:'pointer',
											textAlign:'center',
											 marginBottom:'-0.4rem'
										 }
									 }
							>
								Lista casova
							</h4>
							<UncontrolledCollapse toggler='#toggleClassesList'>
								<CardBody className='mt-2'>
									<AddRemoveList items={this.state.topics.classes}
									   onAdd={this.onAddClassItem}
									   onRemove={this.onRemoveClassesItem}
									   renderItem={this.renderClassesItem}
									   buttonText='Dodaj novu temu'
									/>
								</CardBody>
							</UncontrolledCollapse>
						</Card>
					</Col>
				</Row>

				<Row className='mt-2'>
					<Col>
						<Card>
							<h4 id='toggleTestsList'
								 style=
									 {
										 {
										 	cursor:'pointer',
											textAlign:'center',
											 marginBottom:'-0.4rem'
										 }
									 }
							>
								Lista kolokvijuma
							</h4>
							<UncontrolledCollapse toggler='#toggleTestsList'>
								<CardBody className='mt-2'>
									<AddRemoveList items={this.state.topics.tests}
									   onAdd={this.onAddTestItem}
									   onRemove={this.onRemoveTestsItem}
									   renderItem={this.renderTestsItem}
									   buttonText='Dodaj novi kolokvijum'
									/>
								</CardBody>
							</UncontrolledCollapse>
						</Card>
					</Col>
				</Row>

				<Row className='mt-2'>
					<Col>
						<Card>
							<h4 id='toggleExamsList'
								 style=
									 {
										 {
										 	cursor:'pointer',
											textAlign:'center',
											marginBottom:'-0.4rem'
										 }
									 }
							>
								Lista ispita
							</h4>
							<UncontrolledCollapse toggler='#toggleExamsList'>
								<CardBody className='mt-2'>
									<AddRemoveList items={this.state.topics.exams}
									   onAdd={this.onAddExamItem}
									   onRemove={this.onRemoveExmasItem}
									   renderItem={this.renderExamsItem}
									   buttonText='Dodaj novi ispit'
									/>
								</CardBody>
							</UncontrolledCollapse>
						</Card>
					</Col>
				</Row>

				<Modal style={{minWidth:'70%'}} isOpen={this.state.topicAddDialogData.show}
					   toggle={this.onToggleAddTopicDialog}
				>
					<ModalHeader toggle={this.onToggleAddTopicDialog}>
						{this.state.topicAddDialogData.title}
					</ModalHeader>
					<ModalBody>
						<TopicEdit creating={true}
								   onFinish={this.onTopicAdded}
								   course={{id:this.props.courseId}}
								   topicData={{type:this.state.topicAddDialogData.topicType}}
						/>
					</ModalBody>
				</Modal>

				<YesNoModal yesText='Da'
							noText='Odbaci'
							title='Brisanje teme'
							body={this.state.confirmDeleteDialogData.text}
							isOpen={this.state.confirmDeleteDialogData.show}
							toggle={this.onToggleConfirmDialog}
							onYes={this.onAcceptDelete}
							onNo = {this.onRejectDelete}
				/>

			</React.Fragment>
		);
	}


}

/*Presenter code*/

function topicsAddClass(topics, data)
{
	return 	{classes:[...topics.classes, data]};
}

function topicsAddTest(topics, data)
{
	return {tests:[...topics.tests, data]};
}

function topicsAddExam(topics, data)
{
	return {exams:[...topics.exams, data]};
}

function topicsRemoveClass(topics, index)
{
	const pre = topics.classes.slice(0, index);
	const post = topics.classes.slice(index+1);
	return 	{classes:[...pre, ...post]};
}

function topicsRemoveTest(topics, index)
{
	const pre = topics.tests.slice(0, index);
	const post = topics.tests.slice(index+1);
	return {tests:[...pre, ...post]};
}

function topicsRemoveExam(topics, index)
{
	const pre = topics.exams.slice(0, index);
	const post = topics.exams.slice(index+1);
	return {exams:[...pre, ...post]};
}

function setTopics(topics, data)
{
	return {topics:{...topics, ...data}};
}

function setCourseData(courseData, data)
{
	return {courseData:{...courseData, ...data}};
}

function setCourseDataName(courseData, name)
{
	return {name:name};
}

function setCourseDataShortDescription(courseData, shortDescription)
{
	return {shortDescription: shortDescription};
}

function setTopicAddDialogData(topicAddDialogData, data)
{
	return {topicAddDialogData:{...topicAddDialogData, ...data}};
}

function setTopicAddDialogDataTopicType(topicAddDialogData, type)
{
	return {topicType:type};
}

function setTopicAddDialogDataTitle(topicAddDialogData, title)
{
	return {title:title};
}

function topicAddDialogDataToggle(topicAddDialogData)
{
	return {show:!topicAddDialogData.show};
}

function setConfirmDeleteDialogData(prev, data)
{
	return {confirmDeleteDialogData:{...prev, ...data}};
}

function setConfirmDeleteDialogSelectedItem(prev, item)
{
	return {selectedItem:item};
}

function setConfirmDeleteDialogText(prev, text)
{
	return {text:text};
}

function toggleConfirmDeleteDialog(prev)
{
	return {show:!prev.show};
}

function setConfirmDeleteDialogTopicType(prev, type)
{
	return {topicType:type};
}

function setConfirmDeleteDialogTopicIndex(prev, index)
{
	return {topicIndex:index};
}

/*Helper code*/

export default CourseEditor;